import { Component } from '@verndale/core';
import { secureStorage } from '../helpers/global-storage';

class AlertBanner extends Component {
  private id: string;

  constructor(el: HTMLElement) {
    super(el);
    this.id = this.el.dataset.id || '';
    this.shouldDisplayAlert();
  }

  setupDefaults() {
    this.dom = {
      close: this.el.querySelector<HTMLElement>('.alert-banner__close')
    };
  }

  addListeners() {
    (this.dom.close as HTMLElement)?.addEventListener(
      'click',
      this.handleClose.bind(this)
    );
  }

  shouldDisplayAlert(): void {
    if (secureStorage.get(this.id)) {
      return this.el.remove();
    } else {
      this.el.classList.remove('alert-banner--hidden');
      return;
    }
  }

  handleClose(): void {
    secureStorage.set(this.id, true.toString());
    this.el.remove();
    document.documentElement.style.setProperty(
      '--header-top-offset',
      `${
        (
          document.querySelector('.header') as HTMLElement
        )?.getBoundingClientRect().top
      }px`
    );
  }
}

export default AlertBanner;
